import { apiGet } from "../baseApi";
import { setBuildingData } from "service/mapper";

export const getById = async (id, cancelToken = null) => {
  try {
    const response = await apiGet("_building", {}, id, { cancelToken });
    return { ...response, data: setBuildingData(response.data) };
  } catch (error) {
    return Promise.reject(error);
  }
};
